import { Avatar } from 'antd';
import { createStyles } from 'antd-style';
import { type ComponentType, type CSSProperties, memo } from 'react';

import IconAceMono from '@lobehub/icons/es/Ace/components/Mono.js';
import IconAdobeMono from '@lobehub/icons/es/Adobe/components/Mono.js';
import IconAdobeFireflyMono from '@lobehub/icons/es/AdobeFirefly/components/Mono.js';
import IconAgentVoiceMono from '@lobehub/icons/es/AgentVoice/components/Mono.js';
import IconAgnesAIMono from '@lobehub/icons/es/AgnesAI/components/Mono.js';
import IconAguiMono from '@lobehub/icons/es/Agui/components/Mono.js';
import IconAi2Mono from '@lobehub/icons/es/Ai2/components/Mono.js';
import IconAi21Mono from '@lobehub/icons/es/Ai21/components/Mono.js';
import IconAi302Mono from '@lobehub/icons/es/Ai302/components/Mono.js';
import IconAi360Mono from '@lobehub/icons/es/Ai360/components/Mono.js';
import IconAiHubMixMono from '@lobehub/icons/es/AiHubMix/components/Mono.js';
import IconAiMassMono from '@lobehub/icons/es/AiMass/components/Mono.js';
import IconAionLabsMono from '@lobehub/icons/es/AionLabs/components/Mono.js';
import IconAirJellyMono from '@lobehub/icons/es/AirJelly/components/Mono.js';
import IconAiStudioMono from '@lobehub/icons/es/AiStudio/components/Mono.js';
import IconAkashChatMono from '@lobehub/icons/es/AkashChat/components/Mono.js';
import IconAlephAlphaMono from '@lobehub/icons/es/AlephAlpha/components/Mono.js';
import IconAlibabaMono from '@lobehub/icons/es/Alibaba/components/Mono.js';
import IconAlibabaCloudMono from '@lobehub/icons/es/AlibabaCloud/components/Mono.js';
import IconAMDRadeonCloudMono from '@lobehub/icons/es/AMDRadeonCloud/components/Mono.js';
import IconAmpMono from '@lobehub/icons/es/Amp/components/Mono.js';
import IconAnspireMono from '@lobehub/icons/es/Anspire/components/Mono.js';
import IconAntGroupMono from '@lobehub/icons/es/AntGroup/components/Mono.js';
import IconAnthropicMono from '@lobehub/icons/es/Anthropic/components/Mono.js';
import IconAntigravityMono from '@lobehub/icons/es/Antigravity/components/Mono.js';
import IconAnyscaleMono from '@lobehub/icons/es/Anyscale/components/Mono.js';
import IconApertisMono from '@lobehub/icons/es/Apertis/components/Mono.js';
import IconAppleMono from '@lobehub/icons/es/Apple/components/Mono.js';
import IconArceeMono from '@lobehub/icons/es/Arcee/components/Mono.js';
import IconAskVerdictMono from '@lobehub/icons/es/AskVerdict/components/Mono.js';
import IconAssemblyAIMono from '@lobehub/icons/es/AssemblyAI/components/Mono.js';
import IconAtlasCloudMono from '@lobehub/icons/es/AtlasCloud/components/Mono.js';
import IconAutomaticMono from '@lobehub/icons/es/Automatic/components/Mono.js';
import IconAwsMono from '@lobehub/icons/es/Aws/components/Mono.js';
import IconAyaMono from '@lobehub/icons/es/Aya/components/Mono.js';
import IconAzureMono from '@lobehub/icons/es/Azure/components/Mono.js';
import IconAzureAIMono from '@lobehub/icons/es/AzureAI/components/Mono.js';
import IconBAAIMono from '@lobehub/icons/es/BAAI/components/Mono.js';
import IconBaichuanMono from '@lobehub/icons/es/Baichuan/components/Mono.js';
import IconBaiduMono from '@lobehub/icons/es/Baidu/components/Mono.js';
import IconBaiduCloudMono from '@lobehub/icons/es/BaiduCloud/components/Mono.js';
import IconBailianMono from '@lobehub/icons/es/Bailian/components/Mono.js';
import IconBasetenMono from '@lobehub/icons/es/Baseten/components/Mono.js';
import IconBedrockMono from '@lobehub/icons/es/Bedrock/components/Mono.js';
import IconBflMono from '@lobehub/icons/es/Bfl/components/Mono.js';
import IconBilibiliMono from '@lobehub/icons/es/Bilibili/components/Mono.js';
import IconBilibiliIndexMono from '@lobehub/icons/es/BilibiliIndex/components/Mono.js';
import IconBingMono from '@lobehub/icons/es/Bing/components/Mono.js';
import IconBochaMono from '@lobehub/icons/es/Bocha/components/Mono.js';
import IconBraveMono from '@lobehub/icons/es/Brave/components/Mono.js';
import IconBriaAIMono from '@lobehub/icons/es/BriaAI/components/Mono.js';
import IconBrowserlessMono from '@lobehub/icons/es/Browserless/components/Mono.js';
import IconBurnCloudMono from '@lobehub/icons/es/BurnCloud/components/Mono.js';
import IconByteDanceMono from '@lobehub/icons/es/ByteDance/components/Mono.js';
import IconCapCutMono from '@lobehub/icons/es/CapCut/components/Mono.js';
import IconCelestoAIMono from '@lobehub/icons/es/CelestoAI/components/Mono.js';
import IconCentMLMono from '@lobehub/icons/es/CentML/components/Mono.js';
import IconCerebrasMono from '@lobehub/icons/es/Cerebras/components/Mono.js';
import IconChatGLMMono from '@lobehub/icons/es/ChatGLM/components/Mono.js';
import IconCherryStudioMono from '@lobehub/icons/es/CherryStudio/components/Mono.js';
import IconChutesMono from '@lobehub/icons/es/Chutes/components/Mono.js';
import IconCivitaiMono from '@lobehub/icons/es/Civitai/components/Mono.js';
import IconClaudeMono from '@lobehub/icons/es/Claude/components/Mono.js';
import IconClaudeCodeMono from '@lobehub/icons/es/ClaudeCode/components/Mono.js';
import IconClineMono from '@lobehub/icons/es/Cline/components/Mono.js';
import IconClipdropMono from '@lobehub/icons/es/Clipdrop/components/Mono.js';
import IconCloudflareMono from '@lobehub/icons/es/Cloudflare/components/Mono.js';
import IconCodeBuddyMono from '@lobehub/icons/es/CodeBuddy/components/Mono.js';
import IconCodeFlickerMono from '@lobehub/icons/es/CodeFlicker/components/Mono.js';
import IconCodeGeeXMono from '@lobehub/icons/es/CodeGeeX/components/Mono.js';
import IconCodexMono from '@lobehub/icons/es/Codex/components/Mono.js';
import IconCogVideoMono from '@lobehub/icons/es/CogVideo/components/Mono.js';
import IconCogViewMono from '@lobehub/icons/es/CogView/components/Mono.js';
import IconCohereMono from '@lobehub/icons/es/Cohere/components/Mono.js';
import IconColabMono from '@lobehub/icons/es/Colab/components/Mono.js';
import IconCometAPIMono from '@lobehub/icons/es/CometAPI/components/Mono.js';
import IconComfyUIMono from '@lobehub/icons/es/ComfyUI/components/Mono.js';
import IconCommandAMono from '@lobehub/icons/es/CommandA/components/Mono.js';
import IconCommandCodeMono from '@lobehub/icons/es/CommandCode/components/Mono.js';
import IconCopilotMono from '@lobehub/icons/es/Copilot/components/Mono.js';
import IconCopilotKitMono from '@lobehub/icons/es/CopilotKit/components/Mono.js';
import IconCoquiMono from '@lobehub/icons/es/Coqui/components/Mono.js';
import IconCozeMono from '@lobehub/icons/es/Coze/components/Mono.js';
import IconCrewAIMono from '@lobehub/icons/es/CrewAI/components/Mono.js';
import IconCrusoeMono from '@lobehub/icons/es/Crusoe/components/Mono.js';
import IconCursorMono from '@lobehub/icons/es/Cursor/components/Mono.js';
import IconCyberCutMono from '@lobehub/icons/es/CyberCut/components/Mono.js';
import IconDalleMono from '@lobehub/icons/es/Dalle/components/Mono.js';
import IconDbrxMono from '@lobehub/icons/es/Dbrx/components/Mono.js';
import IconDecartMono from '@lobehub/icons/es/Decart/components/Mono.js';
import IconDeepAIMono from '@lobehub/icons/es/DeepAI/components/Mono.js';
import IconDeepCogitoMono from '@lobehub/icons/es/DeepCogito/components/Mono.js';
import IconDeepInfraMono from '@lobehub/icons/es/DeepInfra/components/Mono.js';
import IconDeepLMono from '@lobehub/icons/es/DeepL/components/Mono.js';
import IconDeepMindMono from '@lobehub/icons/es/DeepMind/components/Mono.js';
import IconDeepSeekMono from '@lobehub/icons/es/DeepSeek/components/Mono.js';
import IconDevinMono from '@lobehub/icons/es/Devin/components/Mono.js';
import IconDifyMono from '@lobehub/icons/es/Dify/components/Mono.js';
import IconDigitalOceanMono from '@lobehub/icons/es/DigitalOcean/components/Mono.js';
import IconDoc2XMono from '@lobehub/icons/es/Doc2X/components/Mono.js';
import IconDocSearchMono from '@lobehub/icons/es/DocSearch/components/Mono.js';
import IconDolphinMono from '@lobehub/icons/es/Dolphin/components/Mono.js';
import IconDotsStudioMono from '@lobehub/icons/es/DotsStudio/components/Mono.js';
import IconDoubaoMono from '@lobehub/icons/es/Doubao/components/Mono.js';
import IconDreamMachineMono from '@lobehub/icons/es/DreamMachine/components/Mono.js';
import IconElevenLabsMono from '@lobehub/icons/es/ElevenLabs/components/Mono.js';
import IconElevenXMono from '@lobehub/icons/es/ElevenX/components/Mono.js';
import IconEssentialAIMono from '@lobehub/icons/es/EssentialAI/components/Mono.js';
import IconExaMono from '@lobehub/icons/es/Exa/components/Mono.js';
import IconFalMono from '@lobehub/icons/es/Fal/components/Mono.js';
import IconFastGPTMono from '@lobehub/icons/es/FastGPT/components/Mono.js';
import IconFeatherlessMono from '@lobehub/icons/es/Featherless/components/Mono.js';
import IconFigmaMono from '@lobehub/icons/es/Figma/components/Mono.js';
import IconFirecrawlMono from '@lobehub/icons/es/Firecrawl/components/Mono.js';
import IconFireworksMono from '@lobehub/icons/es/Fireworks/components/Mono.js';
import IconFishAudioMono from '@lobehub/icons/es/FishAudio/components/Mono.js';
import IconFloraMono from '@lobehub/icons/es/Flora/components/Mono.js';
import IconFlowithMono from '@lobehub/icons/es/Flowith/components/Mono.js';
import IconFluxMono from '@lobehub/icons/es/Flux/components/Mono.js';
import IconFriendliMono from '@lobehub/icons/es/Friendli/components/Mono.js';
import IconGeminiMono from '@lobehub/icons/es/Gemini/components/Mono.js';
import IconGeminiCLIMono from '@lobehub/icons/es/GeminiCLI/components/Mono.js';
import IconGemmaMono from '@lobehub/icons/es/Gemma/components/Mono.js';
import IconGiteeAIMono from '@lobehub/icons/es/GiteeAI/components/Mono.js';
import IconGithubMono from '@lobehub/icons/es/Github/components/Mono.js';
import IconGithubCopilotMono from '@lobehub/icons/es/GithubCopilot/components/Mono.js';
import IconGlamaMono from '@lobehub/icons/es/Glama/components/Mono.js';
import IconGlifMono from '@lobehub/icons/es/Glif/components/Mono.js';
import IconGLMVMono from '@lobehub/icons/es/GLMV/components/Mono.js';
import IconGmiCloudMono from '@lobehub/icons/es/GmiCloud/components/Mono.js';
import IconGoogleMono from '@lobehub/icons/es/Google/components/Mono.js';
import IconGoogleCloudMono from '@lobehub/icons/es/GoogleCloud/components/Mono.js';
import IconGooseMono from '@lobehub/icons/es/Goose/components/Mono.js';
import IconGradioMono from '@lobehub/icons/es/Gradio/components/Mono.js';
import IconGreptileMono from '@lobehub/icons/es/Greptile/components/Mono.js';
import IconGrokMono from '@lobehub/icons/es/Grok/components/Mono.js';
import IconGroqMono from '@lobehub/icons/es/Groq/components/Mono.js';
import IconHailuoMono from '@lobehub/icons/es/Hailuo/components/Mono.js';
import IconHaiperMono from '@lobehub/icons/es/Haiper/components/Mono.js';
import IconHappyHorseMono from '@lobehub/icons/es/HappyHorse/components/Mono.js';
import IconHedraMono from '@lobehub/icons/es/Hedra/components/Mono.js';
import IconHermesAgentMono from '@lobehub/icons/es/HermesAgent/components/Mono.js';
import IconHigressMono from '@lobehub/icons/es/Higress/components/Mono.js';
import IconHuaweiMono from '@lobehub/icons/es/Huawei/components/Mono.js';
import IconHuaweiCloudMono from '@lobehub/icons/es/HuaweiCloud/components/Mono.js';
import IconHuggingFaceMono from '@lobehub/icons/es/HuggingFace/components/Mono.js';
import IconHunyuanMono from '@lobehub/icons/es/Hunyuan/components/Mono.js';
import IconHyperbolicMono from '@lobehub/icons/es/Hyperbolic/components/Mono.js';
import IconIBMMono from '@lobehub/icons/es/IBM/components/Mono.js';
import IconIdeogramMono from '@lobehub/icons/es/Ideogram/components/Mono.js';
import IconIFlyTekCloudMono from '@lobehub/icons/es/IFlyTekCloud/components/Mono.js';
import IconInceptionMono from '@lobehub/icons/es/Inception/components/Mono.js';
import IconInceptronMono from '@lobehub/icons/es/Inceptron/components/Mono.js';
import IconInferenceMono from '@lobehub/icons/es/Inference/components/Mono.js';
import IconInfermaticMono from '@lobehub/icons/es/Infermatic/components/Mono.js';
import IconInfinigenceMono from '@lobehub/icons/es/Infinigence/components/Mono.js';
import IconInflectionMono from '@lobehub/icons/es/Inflection/components/Mono.js';
import IconInternLMMono from '@lobehub/icons/es/InternLM/components/Mono.js';
import IconIoNetMono from '@lobehub/icons/es/IoNet/components/Mono.js';
import IconJimengMono from '@lobehub/icons/es/Jimeng/components/Mono.js';
import IconJinaMono from '@lobehub/icons/es/Jina/components/Mono.js';
import IconJunieMono from '@lobehub/icons/es/Junie/components/Mono.js';
import IconKagiMono from '@lobehub/icons/es/Kagi/components/Mono.js';
import IconKiloCodeMono from '@lobehub/icons/es/KiloCode/components/Mono.js';
import IconKimiMono from '@lobehub/icons/es/Kimi/components/Mono.js';
import IconKiroMono from '@lobehub/icons/es/Kiro/components/Mono.js';
import IconKlingMono from '@lobehub/icons/es/Kling/components/Mono.js';
import IconKlusterMono from '@lobehub/icons/es/Kluster/components/Mono.js';
import IconKolorsMono from '@lobehub/icons/es/Kolors/components/Mono.js';
import IconKreaMono from '@lobehub/icons/es/Krea/components/Mono.js';
import IconKwaiKATMono from '@lobehub/icons/es/KwaiKAT/components/Mono.js';
import IconKwaipilotMono from '@lobehub/icons/es/Kwaipilot/components/Mono.js';
import IconLambdaMono from '@lobehub/icons/es/Lambda/components/Mono.js';
import IconLangChainMono from '@lobehub/icons/es/LangChain/components/Mono.js';
import IconLangfuseMono from '@lobehub/icons/es/Langfuse/components/Mono.js';
import IconLangGraphMono from '@lobehub/icons/es/LangGraph/components/Mono.js';
import IconLangSmithMono from '@lobehub/icons/es/LangSmith/components/Mono.js';
import IconLeptonAIMono from '@lobehub/icons/es/LeptonAI/components/Mono.js';
import IconLGMono from '@lobehub/icons/es/LG/components/Mono.js';
import IconLightricksMono from '@lobehub/icons/es/Lightricks/components/Mono.js';
import IconLiquidMono from '@lobehub/icons/es/Liquid/components/Mono.js';
import IconLiveKitMono from '@lobehub/icons/es/LiveKit/components/Mono.js';
import IconLlamaIndexMono from '@lobehub/icons/es/LlamaIndex/components/Mono.js';
import IconLLaVAMono from '@lobehub/icons/es/LLaVA/components/Mono.js';
import IconLlmApiMono from '@lobehub/icons/es/LlmApi/components/Mono.js';
import IconLmStudioMono from '@lobehub/icons/es/LmStudio/components/Mono.js';
import IconLobeHubMono from '@lobehub/icons/es/LobeHub/components/Mono.js';
import IconLongCatMono from '@lobehub/icons/es/LongCat/components/Mono.js';
import IconLovableMono from '@lobehub/icons/es/Lovable/components/Mono.js';
import IconLovartMono from '@lobehub/icons/es/Lovart/components/Mono.js';
import IconLumaMono from '@lobehub/icons/es/Luma/components/Mono.js';
import IconMagicMono from '@lobehub/icons/es/Magic/components/Mono.js';
import IconMakeMono from '@lobehub/icons/es/Make/components/Mono.js';
import IconManusMono from '@lobehub/icons/es/Manus/components/Mono.js';
import IconMastraMono from '@lobehub/icons/es/Mastra/components/Mono.js';
import IconMCPMono from '@lobehub/icons/es/MCP/components/Mono.js';
import IconMcpSoMono from '@lobehub/icons/es/McpSo/components/Mono.js';
import IconMenloMono from '@lobehub/icons/es/Menlo/components/Mono.js';
import IconMeshyMono from '@lobehub/icons/es/Meshy/components/Mono.js';
import IconMetaMono from '@lobehub/icons/es/Meta/components/Mono.js';
import IconMetaAIMono from '@lobehub/icons/es/MetaAI/components/Mono.js';
import IconMetaGPTMono from '@lobehub/icons/es/MetaGPT/components/Mono.js';
import IconMicrosoftMono from '@lobehub/icons/es/Microsoft/components/Mono.js';
import IconMidjourneyMono from '@lobehub/icons/es/Midjourney/components/Mono.js';
import IconMinimaxMono from '@lobehub/icons/es/Minimax/components/Mono.js';
import IconMistralMono from '@lobehub/icons/es/Mistral/components/Mono.js';
import IconModelScopeMono from '@lobehub/icons/es/ModelScope/components/Mono.js';
import IconMonicaMono from '@lobehub/icons/es/Monica/components/Mono.js';
import IconMoonshotMono from '@lobehub/icons/es/Moonshot/components/Mono.js';
import IconMorphMono from '@lobehub/icons/es/Morph/components/Mono.js';
import IconMoxtMono from '@lobehub/icons/es/Moxt/components/Mono.js';
import IconMyShellMono from '@lobehub/icons/es/MyShell/components/Mono.js';
import IconN8nMono from '@lobehub/icons/es/N8n/components/Mono.js';
import IconNanoBananaMono from '@lobehub/icons/es/NanoBanana/components/Mono.js';
import IconNebiusMono from '@lobehub/icons/es/Nebius/components/Mono.js';
import IconNewAPIMono from '@lobehub/icons/es/NewAPI/components/Mono.js';
import IconNextbitMono from '@lobehub/icons/es/Nextbit/components/Mono.js';
import IconNotebookLMMono from '@lobehub/icons/es/NotebookLM/components/Mono.js';
import IconNotionMono from '@lobehub/icons/es/Notion/components/Mono.js';
import IconNousResearchMono from '@lobehub/icons/es/NousResearch/components/Mono.js';
import IconNovaMono from '@lobehub/icons/es/Nova/components/Mono.js';
import IconNovelAIMono from '@lobehub/icons/es/NovelAI/components/Mono.js';
import IconNovitaMono from '@lobehub/icons/es/Novita/components/Mono.js';
import IconNPLCloudMono from '@lobehub/icons/es/NPLCloud/components/Mono.js';
import IconNvidiaMono from '@lobehub/icons/es/Nvidia/components/Mono.js';
import IconObsidianMono from '@lobehub/icons/es/Obsidian/components/Mono.js';
import IconOllamaMono from '@lobehub/icons/es/Ollama/components/Mono.js';
import IconOpenAIMono from '@lobehub/icons/es/OpenAI/components/Mono.js';
import IconOpenChatMono from '@lobehub/icons/es/OpenChat/components/Mono.js';
import IconOpenClawMono from '@lobehub/icons/es/OpenClaw/components/Mono.js';
import IconOpenCodeMono from '@lobehub/icons/es/OpenCode/components/Mono.js';
import IconOpenHandsMono from '@lobehub/icons/es/OpenHands/components/Mono.js';
import IconOpenHumanMono from '@lobehub/icons/es/OpenHuman/components/Mono.js';
import IconOpenRouterMono from '@lobehub/icons/es/OpenRouter/components/Mono.js';
import IconOpenWebUIMono from '@lobehub/icons/es/OpenWebUI/components/Mono.js';
import IconPaLMMono from '@lobehub/icons/es/PaLM/components/Mono.js';
import IconParasailMono from '@lobehub/icons/es/Parasail/components/Mono.js';
import IconPerceptronMono from '@lobehub/icons/es/Perceptron/components/Mono.js';
import IconPerplexityMono from '@lobehub/icons/es/Perplexity/components/Mono.js';
import IconPhalaMono from '@lobehub/icons/es/Phala/components/Mono.js';
import IconPhidataMono from '@lobehub/icons/es/Phidata/components/Mono.js';
import IconPhindMono from '@lobehub/icons/es/Phind/components/Mono.js';
import IconPiMono from '@lobehub/icons/es/Pi/components/Mono.js';
import IconPikaMono from '@lobehub/icons/es/Pika/components/Mono.js';
import IconPixVerseMono from '@lobehub/icons/es/PixVerse/components/Mono.js';
import IconPlayer2Mono from '@lobehub/icons/es/Player2/components/Mono.js';
import IconPoeMono from '@lobehub/icons/es/Poe/components/Mono.js';
import IconPollinationsMono from '@lobehub/icons/es/Pollinations/components/Mono.js';
import IconPoolsideMono from '@lobehub/icons/es/Poolside/components/Mono.js';
import IconPPIOMono from '@lobehub/icons/es/PPIO/components/Mono.js';
import IconPrunaAIMono from '@lobehub/icons/es/PrunaAI/components/Mono.js';
import IconPydanticAIMono from '@lobehub/icons/es/PydanticAI/components/Mono.js';
import IconQingyanMono from '@lobehub/icons/es/Qingyan/components/Mono.js';
import IconQiniuMono from '@lobehub/icons/es/Qiniu/components/Mono.js';
import IconQoderMono from '@lobehub/icons/es/Qoder/components/Mono.js';
import IconQwenMono from '@lobehub/icons/es/Qwen/components/Mono.js';
import IconRailwayMono from '@lobehub/icons/es/Railway/components/Mono.js';
import IconRecraftMono from '@lobehub/icons/es/Recraft/components/Mono.js';
import IconRekaMono from '@lobehub/icons/es/Reka/components/Mono.js';
import IconRelaceMono from '@lobehub/icons/es/Relace/components/Mono.js';
import IconReplicateMono from '@lobehub/icons/es/Replicate/components/Mono.js';
import IconReplitMono from '@lobehub/icons/es/Replit/components/Mono.js';
import IconReveMono from '@lobehub/icons/es/Reve/components/Mono.js';
import IconRooCodeMono from '@lobehub/icons/es/RooCode/components/Mono.js';
import IconRSSHubMono from '@lobehub/icons/es/RSSHub/components/Mono.js';
import IconRunwayMono from '@lobehub/icons/es/Runway/components/Mono.js';
import IconRwkvMono from '@lobehub/icons/es/Rwkv/components/Mono.js';
import IconSakanaMono from '@lobehub/icons/es/Sakana/components/Mono.js';
import IconSambaNovaMono from '@lobehub/icons/es/SambaNova/components/Mono.js';
import IconSearch1APIMono from '@lobehub/icons/es/Search1API/components/Mono.js';
import IconSearchApiMono from '@lobehub/icons/es/SearchApi/components/Mono.js';
import IconSearXNGMono from '@lobehub/icons/es/SearXNG/components/Mono.js';
import IconSenseNovaMono from '@lobehub/icons/es/SenseNova/components/Mono.js';
import IconSiliconCloudMono from '@lobehub/icons/es/SiliconCloud/components/Mono.js';
import IconSillyTavernMono from '@lobehub/icons/es/SillyTavern/components/Mono.js';
import IconSkyworkMono from '@lobehub/icons/es/Skywork/components/Mono.js';
import IconSlockMono from '@lobehub/icons/es/Slock/components/Mono.js';
import IconSmitheryMono from '@lobehub/icons/es/Smithery/components/Mono.js';
import IconSnowflakeMono from '@lobehub/icons/es/Snowflake/components/Mono.js';
import IconSophNetMono from '@lobehub/icons/es/SophNet/components/Mono.js';
import IconSoraMono from '@lobehub/icons/es/Sora/components/Mono.js';
import IconSparkMono from '@lobehub/icons/es/Spark/components/Mono.js';
import IconSpeedAIMono from '@lobehub/icons/es/SpeedAI/components/Mono.js';
import IconStabilityMono from '@lobehub/icons/es/Stability/components/Mono.js';
import IconStateCloudMono from '@lobehub/icons/es/StateCloud/components/Mono.js';
import IconStepfunMono from '@lobehub/icons/es/Stepfun/components/Mono.js';
import IconStraicoMono from '@lobehub/icons/es/Straico/components/Mono.js';
import IconStreamLakeMono from '@lobehub/icons/es/StreamLake/components/Mono.js';
import IconSubModelMono from '@lobehub/icons/es/SubModel/components/Mono.js';
import IconSunoMono from '@lobehub/icons/es/Suno/components/Mono.js';
import IconSyncMono from '@lobehub/icons/es/Sync/components/Mono.js';
import IconTargonMono from '@lobehub/icons/es/Targon/components/Mono.js';
import IconTavilyMono from '@lobehub/icons/es/Tavily/components/Mono.js';
import IconTencentMono from '@lobehub/icons/es/Tencent/components/Mono.js';
import IconTencentCloudMono from '@lobehub/icons/es/TencentCloud/components/Mono.js';
import IconTiangongMono from '@lobehub/icons/es/Tiangong/components/Mono.js';
import IconTIIMono from '@lobehub/icons/es/TII/components/Mono.js';
import IconTogetherMono from '@lobehub/icons/es/Together/components/Mono.js';
import IconTopazLabsMono from '@lobehub/icons/es/TopazLabs/components/Mono.js';
import IconTraeMono from '@lobehub/icons/es/Trae/components/Mono.js';
import IconTripoMono from '@lobehub/icons/es/Tripo/components/Mono.js';
import IconTuriXMono from '@lobehub/icons/es/TuriX/components/Mono.js';
import IconUdioMono from '@lobehub/icons/es/Udio/components/Mono.js';
import IconUnionAlphaMono from '@lobehub/icons/es/UnionAlpha/components/Mono.js';
import IconUnslothMono from '@lobehub/icons/es/Unsloth/components/Mono.js';
import IconUnstructuredMono from '@lobehub/icons/es/Unstructured/components/Mono.js';
import IconUpstageMono from '@lobehub/icons/es/Upstage/components/Mono.js';
import IconV0Mono from '@lobehub/icons/es/V0/components/Mono.js';
import IconVectorizerAIMono from '@lobehub/icons/es/VectorizerAI/components/Mono.js';
import IconVeniceMono from '@lobehub/icons/es/Venice/components/Mono.js';
import IconVercelMono from '@lobehub/icons/es/Vercel/components/Mono.js';
import IconVertexAIMono from '@lobehub/icons/es/VertexAI/components/Mono.js';
import IconViduMono from '@lobehub/icons/es/Vidu/components/Mono.js';
import IconViggleMono from '@lobehub/icons/es/Viggle/components/Mono.js';
import IconVllmMono from '@lobehub/icons/es/Vllm/components/Mono.js';
import IconVolcengineMono from '@lobehub/icons/es/Volcengine/components/Mono.js';
import IconVoyageMono from '@lobehub/icons/es/Voyage/components/Mono.js';
import IconWaferMono from '@lobehub/icons/es/Wafer/components/Mono.js';
import IconWandbMono from '@lobehub/icons/es/Wandb/components/Mono.js';
import IconWaveSpeedMono from '@lobehub/icons/es/WaveSpeed/components/Mono.js';
import IconWenxinMono from '@lobehub/icons/es/Wenxin/components/Mono.js';
import IconWindsurfMono from '@lobehub/icons/es/Windsurf/components/Mono.js';
import IconWorkersAIMono from '@lobehub/icons/es/WorkersAI/components/Mono.js';
import IconWorldRouterMono from '@lobehub/icons/es/WorldRouter/components/Mono.js';
import IconXAIMono from '@lobehub/icons/es/XAI/components/Mono.js';
import IconXiaomiMiMoMono from '@lobehub/icons/es/XiaomiMiMo/components/Mono.js';
import IconXinferenceMono from '@lobehub/icons/es/Xinference/components/Mono.js';
import IconXpayMono from '@lobehub/icons/es/Xpay/components/Mono.js';
import IconXuanyuanMono from '@lobehub/icons/es/Xuanyuan/components/Mono.js';
import IconYandexMono from '@lobehub/icons/es/Yandex/components/Mono.js';
import IconYiMono from '@lobehub/icons/es/Yi/components/Mono.js';
import IconYouMindMono from '@lobehub/icons/es/YouMind/components/Mono.js';
import IconYuanbaoMono from '@lobehub/icons/es/Yuanbao/components/Mono.js';
import IconZAIMono from '@lobehub/icons/es/ZAI/components/Mono.js';
import IconZapierMono from '@lobehub/icons/es/Zapier/components/Mono.js';
import IconZeaburMono from '@lobehub/icons/es/Zeabur/components/Mono.js';
import IconZencoderMono from '@lobehub/icons/es/Zencoder/components/Mono.js';
import IconZenMuxMono from '@lobehub/icons/es/ZenMux/components/Mono.js';
import IconZeroOneMono from '@lobehub/icons/es/ZeroOne/components/Mono.js';
import IconZhipuMono from '@lobehub/icons/es/Zhipu/components/Mono.js';
import IconAdobeColor from '@lobehub/icons/es/Adobe/components/Color.js';
import IconAdobeFireflyColor from '@lobehub/icons/es/AdobeFirefly/components/Color.js';
import IconAgentVoiceColor from '@lobehub/icons/es/AgentVoice/components/Color.js';
import IconAi2Color from '@lobehub/icons/es/Ai2/components/Color.js';
import IconAi302Color from '@lobehub/icons/es/Ai302/components/Color.js';
import IconAi360Color from '@lobehub/icons/es/Ai360/components/Color.js';
import IconAiHubMixColor from '@lobehub/icons/es/AiHubMix/components/Color.js';
import IconAiMassColor from '@lobehub/icons/es/AiMass/components/Color.js';
import IconAionLabsColor from '@lobehub/icons/es/AionLabs/components/Color.js';
import IconAirJellyColor from '@lobehub/icons/es/AirJelly/components/Color.js';
import IconAkashChatColor from '@lobehub/icons/es/AkashChat/components/Color.js';
import IconAlibabaColor from '@lobehub/icons/es/Alibaba/components/Color.js';
import IconAlibabaCloudColor from '@lobehub/icons/es/AlibabaCloud/components/Color.js';
import IconAMDRadeonCloudColor from '@lobehub/icons/es/AMDRadeonCloud/components/Color.js';
import IconAmpColor from '@lobehub/icons/es/Amp/components/Color.js';
import IconAnspireColor from '@lobehub/icons/es/Anspire/components/Color.js';
import IconAntGroupColor from '@lobehub/icons/es/AntGroup/components/Color.js';
import IconAntigravityColor from '@lobehub/icons/es/Antigravity/components/Color.js';
import IconAnyscaleColor from '@lobehub/icons/es/Anyscale/components/Color.js';
import IconApertisColor from '@lobehub/icons/es/Apertis/components/Color.js';
import IconArceeColor from '@lobehub/icons/es/Arcee/components/Color.js';
import IconAskVerdictColor from '@lobehub/icons/es/AskVerdict/components/Color.js';
import IconAssemblyAIColor from '@lobehub/icons/es/AssemblyAI/components/Color.js';
import IconAutomaticColor from '@lobehub/icons/es/Automatic/components/Color.js';
import IconAwsColor from '@lobehub/icons/es/Aws/components/Color.js';
import IconAyaColor from '@lobehub/icons/es/Aya/components/Color.js';
import IconAzureColor from '@lobehub/icons/es/Azure/components/Color.js';
import IconAzureAIColor from '@lobehub/icons/es/AzureAI/components/Color.js';
import IconBaichuanColor from '@lobehub/icons/es/Baichuan/components/Color.js';
import IconBaiduColor from '@lobehub/icons/es/Baidu/components/Color.js';
import IconBaiduCloudColor from '@lobehub/icons/es/BaiduCloud/components/Color.js';
import IconBailianColor from '@lobehub/icons/es/Bailian/components/Color.js';
import IconBedrockColor from '@lobehub/icons/es/Bedrock/components/Color.js';
import IconBilibiliColor from '@lobehub/icons/es/Bilibili/components/Color.js';
import IconBingColor from '@lobehub/icons/es/Bing/components/Color.js';
import IconBochaColor from '@lobehub/icons/es/Bocha/components/Color.js';
import IconBraveColor from '@lobehub/icons/es/Brave/components/Color.js';
import IconBriaAIColor from '@lobehub/icons/es/BriaAI/components/Color.js';
import IconBurnCloudColor from '@lobehub/icons/es/BurnCloud/components/Color.js';
import IconByteDanceColor from '@lobehub/icons/es/ByteDance/components/Color.js';
import IconCelestoAIColor from '@lobehub/icons/es/CelestoAI/components/Color.js';
import IconCentMLColor from '@lobehub/icons/es/CentML/components/Color.js';
import IconCerebrasColor from '@lobehub/icons/es/Cerebras/components/Color.js';
import IconChatGLMColor from '@lobehub/icons/es/ChatGLM/components/Color.js';
import IconCherryStudioColor from '@lobehub/icons/es/CherryStudio/components/Color.js';
import IconCivitaiColor from '@lobehub/icons/es/Civitai/components/Color.js';
import IconClaudeColor from '@lobehub/icons/es/Claude/components/Color.js';
import IconClaudeCodeColor from '@lobehub/icons/es/ClaudeCode/components/Color.js';
import IconCloudflareColor from '@lobehub/icons/es/Cloudflare/components/Color.js';
import IconCodeBuddyColor from '@lobehub/icons/es/CodeBuddy/components/Color.js';
import IconCodeFlickerColor from '@lobehub/icons/es/CodeFlicker/components/Color.js';
import IconCodeGeeXColor from '@lobehub/icons/es/CodeGeeX/components/Color.js';
import IconCodexColor from '@lobehub/icons/es/Codex/components/Color.js';
import IconCogVideoColor from '@lobehub/icons/es/CogVideo/components/Color.js';
import IconCogViewColor from '@lobehub/icons/es/CogView/components/Color.js';
import IconCohereColor from '@lobehub/icons/es/Cohere/components/Color.js';
import IconColabColor from '@lobehub/icons/es/Colab/components/Color.js';
import IconCometAPIColor from '@lobehub/icons/es/CometAPI/components/Color.js';
import IconComfyUIColor from '@lobehub/icons/es/ComfyUI/components/Color.js';
import IconCommandAColor from '@lobehub/icons/es/CommandA/components/Color.js';
import IconCommandCodeColor from '@lobehub/icons/es/CommandCode/components/Color.js';
import IconCopilotColor from '@lobehub/icons/es/Copilot/components/Color.js';
import IconCopilotKitColor from '@lobehub/icons/es/CopilotKit/components/Color.js';
import IconCoquiColor from '@lobehub/icons/es/Coqui/components/Color.js';
import IconCrewAIColor from '@lobehub/icons/es/CrewAI/components/Color.js';
import IconCrusoeColor from '@lobehub/icons/es/Crusoe/components/Color.js';
import IconDalleColor from '@lobehub/icons/es/Dalle/components/Color.js';
import IconDbrxColor from '@lobehub/icons/es/Dbrx/components/Color.js';
import IconDecartColor from '@lobehub/icons/es/Decart/components/Color.js';
import IconDeepCogitoColor from '@lobehub/icons/es/DeepCogito/components/Color.js';
import IconDeepInfraColor from '@lobehub/icons/es/DeepInfra/components/Color.js';
import IconDeepLColor from '@lobehub/icons/es/DeepL/components/Color.js';
import IconDeepMindColor from '@lobehub/icons/es/DeepMind/components/Color.js';
import IconDeepSeekColor from '@lobehub/icons/es/DeepSeek/components/Color.js';
import IconDevinColor from '@lobehub/icons/es/Devin/components/Color.js';
import IconDifyColor from '@lobehub/icons/es/Dify/components/Color.js';
import IconDoc2XColor from '@lobehub/icons/es/Doc2X/components/Color.js';
import IconDocSearchColor from '@lobehub/icons/es/DocSearch/components/Color.js';
import IconDoubaoColor from '@lobehub/icons/es/Doubao/components/Color.js';
import IconEssentialAIColor from '@lobehub/icons/es/EssentialAI/components/Color.js';
import IconExaColor from '@lobehub/icons/es/Exa/components/Color.js';
import IconFalColor from '@lobehub/icons/es/Fal/components/Color.js';
import IconFastGPTColor from '@lobehub/icons/es/FastGPT/components/Color.js';
import IconFeatherlessColor from '@lobehub/icons/es/Featherless/components/Color.js';
import IconFigmaColor from '@lobehub/icons/es/Figma/components/Color.js';
import IconFirecrawlColor from '@lobehub/icons/es/Firecrawl/components/Color.js';
import IconFireworksColor from '@lobehub/icons/es/Fireworks/components/Color.js';
import IconGeminiColor from '@lobehub/icons/es/Gemini/components/Color.js';
import IconGeminiCLIColor from '@lobehub/icons/es/GeminiCLI/components/Color.js';
import IconGemmaColor from '@lobehub/icons/es/Gemma/components/Color.js';
import IconGLMVColor from '@lobehub/icons/es/GLMV/components/Color.js';
import IconGoogleColor from '@lobehub/icons/es/Google/components/Color.js';
import IconGoogleCloudColor from '@lobehub/icons/es/GoogleCloud/components/Color.js';
import IconGradioColor from '@lobehub/icons/es/Gradio/components/Color.js';
import IconGreptileColor from '@lobehub/icons/es/Greptile/components/Color.js';
import IconHailuoColor from '@lobehub/icons/es/Hailuo/components/Color.js';
import IconHigressColor from '@lobehub/icons/es/Higress/components/Color.js';
import IconHuaweiColor from '@lobehub/icons/es/Huawei/components/Color.js';
import IconHuaweiCloudColor from '@lobehub/icons/es/HuaweiCloud/components/Color.js';
import IconHuggingFaceColor from '@lobehub/icons/es/HuggingFace/components/Color.js';
import IconHunyuanColor from '@lobehub/icons/es/Hunyuan/components/Color.js';
import IconHyperbolicColor from '@lobehub/icons/es/Hyperbolic/components/Color.js';
import IconIFlyTekCloudColor from '@lobehub/icons/es/IFlyTekCloud/components/Color.js';
import IconInceptronColor from '@lobehub/icons/es/Inceptron/components/Color.js';
import IconInfermaticColor from '@lobehub/icons/es/Infermatic/components/Color.js';
import IconInfinigenceColor from '@lobehub/icons/es/Infinigence/components/Color.js';
import IconInternLMColor from '@lobehub/icons/es/InternLM/components/Color.js';
import IconJimengColor from '@lobehub/icons/es/Jimeng/components/Color.js';
import IconJunieColor from '@lobehub/icons/es/Junie/components/Color.js';
import IconKimiColor from '@lobehub/icons/es/Kimi/components/Color.js';
import IconKiroColor from '@lobehub/icons/es/Kiro/components/Color.js';
import IconKlingColor from '@lobehub/icons/es/Kling/components/Color.js';
import IconKlusterColor from '@lobehub/icons/es/Kluster/components/Color.js';
import IconKolorsColor from '@lobehub/icons/es/Kolors/components/Color.js';
import IconKwaipilotColor from '@lobehub/icons/es/Kwaipilot/components/Color.js';
import IconLangChainColor from '@lobehub/icons/es/LangChain/components/Color.js';
import IconLangfuseColor from '@lobehub/icons/es/Langfuse/components/Color.js';
import IconLangGraphColor from '@lobehub/icons/es/LangGraph/components/Color.js';
import IconLangSmithColor from '@lobehub/icons/es/LangSmith/components/Color.js';
import IconLeptonAIColor from '@lobehub/icons/es/LeptonAI/components/Color.js';
import IconLGColor from '@lobehub/icons/es/LG/components/Color.js';
import IconLiveKitColor from '@lobehub/icons/es/LiveKit/components/Color.js';
import IconLlamaIndexColor from '@lobehub/icons/es/LlamaIndex/components/Color.js';
import IconLLaVAColor from '@lobehub/icons/es/LLaVA/components/Color.js';
import IconLlmApiColor from '@lobehub/icons/es/LlmApi/components/Color.js';
import IconLobeHubColor from '@lobehub/icons/es/LobeHub/components/Color.js';
import IconLongCatColor from '@lobehub/icons/es/LongCat/components/Color.js';
import IconLovableColor from '@lobehub/icons/es/Lovable/components/Color.js';
import IconLumaColor from '@lobehub/icons/es/Luma/components/Color.js';
import IconMakeColor from '@lobehub/icons/es/Make/components/Color.js';
import IconMcpSoColor from '@lobehub/icons/es/McpSo/components/Color.js';
import IconMenloColor from '@lobehub/icons/es/Menlo/components/Color.js';
import IconMeshyColor from '@lobehub/icons/es/Meshy/components/Color.js';
import IconMetaColor from '@lobehub/icons/es/Meta/components/Color.js';
import IconMetaAIColor from '@lobehub/icons/es/MetaAI/components/Color.js';
import IconMicrosoftColor from '@lobehub/icons/es/Microsoft/components/Color.js';
import IconMinimaxColor from '@lobehub/icons/es/Minimax/components/Color.js';
import IconMistralColor from '@lobehub/icons/es/Mistral/components/Color.js';
import IconModelScopeColor from '@lobehub/icons/es/ModelScope/components/Color.js';
import IconMonicaColor from '@lobehub/icons/es/Monica/components/Color.js';
import IconMorphColor from '@lobehub/icons/es/Morph/components/Color.js';
import IconMoxtColor from '@lobehub/icons/es/Moxt/components/Color.js';
import IconMyShellColor from '@lobehub/icons/es/MyShell/components/Color.js';
import IconN8nColor from '@lobehub/icons/es/N8n/components/Color.js';
import IconNanoBananaColor from '@lobehub/icons/es/NanoBanana/components/Color.js';
import IconNewAPIColor from '@lobehub/icons/es/NewAPI/components/Color.js';
import IconNextbitColor from '@lobehub/icons/es/Nextbit/components/Color.js';
import IconNovaColor from '@lobehub/icons/es/Nova/components/Color.js';
import IconNovitaColor from '@lobehub/icons/es/Novita/components/Color.js';
import IconNPLCloudColor from '@lobehub/icons/es/NPLCloud/components/Color.js';
import IconNvidiaColor from '@lobehub/icons/es/Nvidia/components/Color.js';
import IconObsidianColor from '@lobehub/icons/es/Obsidian/components/Color.js';
import IconOpenChatColor from '@lobehub/icons/es/OpenChat/components/Color.js';
import IconOpenClawColor from '@lobehub/icons/es/OpenClaw/components/Color.js';
import IconOpenHandsColor from '@lobehub/icons/es/OpenHands/components/Color.js';
import IconOpenRouterColor from '@lobehub/icons/es/OpenRouter/components/Color.js';
import IconPaLMColor from '@lobehub/icons/es/PaLM/components/Color.js';
import IconPerplexityColor from '@lobehub/icons/es/Perplexity/components/Color.js';
import IconPhalaColor from '@lobehub/icons/es/Phala/components/Color.js';
import IconPhidataColor from '@lobehub/icons/es/Phidata/components/Color.js';
import IconPixVerseColor from '@lobehub/icons/es/PixVerse/components/Color.js';
import IconPlayer2Color from '@lobehub/icons/es/Player2/components/Color.js';
import IconPoeColor from '@lobehub/icons/es/Poe/components/Color.js';
import IconPoolsideColor from '@lobehub/icons/es/Poolside/components/Color.js';
import IconPPIOColor from '@lobehub/icons/es/PPIO/components/Color.js';
import IconPrunaAIColor from '@lobehub/icons/es/PrunaAI/components/Color.js';
import IconPydanticAIColor from '@lobehub/icons/es/PydanticAI/components/Color.js';
import IconQingyanColor from '@lobehub/icons/es/Qingyan/components/Color.js';
import IconQiniuColor from '@lobehub/icons/es/Qiniu/components/Color.js';
import IconQoderColor from '@lobehub/icons/es/Qoder/components/Color.js';
import IconQwenColor from '@lobehub/icons/es/Qwen/components/Color.js';
import IconReplitColor from '@lobehub/icons/es/Replit/components/Color.js';
import IconRSSHubColor from '@lobehub/icons/es/RSSHub/components/Color.js';
import IconRwkvColor from '@lobehub/icons/es/Rwkv/components/Color.js';
import IconSakanaColor from '@lobehub/icons/es/Sakana/components/Color.js';
import IconSambaNovaColor from '@lobehub/icons/es/SambaNova/components/Color.js';
import IconSearch1APIColor from '@lobehub/icons/es/Search1API/components/Color.js';
import IconSearXNGColor from '@lobehub/icons/es/SearXNG/components/Color.js';
import IconSenseNovaColor from '@lobehub/icons/es/SenseNova/components/Color.js';
import IconSiliconCloudColor from '@lobehub/icons/es/SiliconCloud/components/Color.js';
import IconSillyTavernColor from '@lobehub/icons/es/SillyTavern/components/Color.js';
import IconSkyworkColor from '@lobehub/icons/es/Skywork/components/Color.js';
import IconSmitheryColor from '@lobehub/icons/es/Smithery/components/Color.js';
import IconSnowflakeColor from '@lobehub/icons/es/Snowflake/components/Color.js';
import IconSophNetColor from '@lobehub/icons/es/SophNet/components/Color.js';
import IconSoraColor from '@lobehub/icons/es/Sora/components/Color.js';
import IconSparkColor from '@lobehub/icons/es/Spark/components/Color.js';
import IconSpeedAIColor from '@lobehub/icons/es/SpeedAI/components/Color.js';
import IconStabilityColor from '@lobehub/icons/es/Stability/components/Color.js';
import IconStateCloudColor from '@lobehub/icons/es/StateCloud/components/Color.js';
import IconStraicoColor from '@lobehub/icons/es/Straico/components/Color.js';
import IconStreamLakeColor from '@lobehub/icons/es/StreamLake/components/Color.js';
import IconSubModelColor from '@lobehub/icons/es/SubModel/components/Color.js';
import IconTargonColor from '@lobehub/icons/es/Targon/components/Color.js';
import IconTavilyColor from '@lobehub/icons/es/Tavily/components/Color.js';
import IconTencentColor from '@lobehub/icons/es/Tencent/components/Color.js';
import IconTencentCloudColor from '@lobehub/icons/es/TencentCloud/components/Color.js';
import IconTiangongColor from '@lobehub/icons/es/Tiangong/components/Color.js';
import IconTIIColor from '@lobehub/icons/es/TII/components/Color.js';
import IconTogetherColor from '@lobehub/icons/es/Together/components/Color.js';
import IconTraeColor from '@lobehub/icons/es/Trae/components/Color.js';
import IconTripoColor from '@lobehub/icons/es/Tripo/components/Color.js';
import IconUdioColor from '@lobehub/icons/es/Udio/components/Color.js';
import IconUnionAlphaColor from '@lobehub/icons/es/UnionAlpha/components/Color.js';
import IconUnslothColor from '@lobehub/icons/es/Unsloth/components/Color.js';
import IconUnstructuredColor from '@lobehub/icons/es/Unstructured/components/Color.js';
import IconUpstageColor from '@lobehub/icons/es/Upstage/components/Color.js';
import IconVeniceColor from '@lobehub/icons/es/Venice/components/Color.js';
import IconVertexAIColor from '@lobehub/icons/es/VertexAI/components/Color.js';
import IconViduColor from '@lobehub/icons/es/Vidu/components/Color.js';
import IconVllmColor from '@lobehub/icons/es/Vllm/components/Color.js';
import IconVolcengineColor from '@lobehub/icons/es/Volcengine/components/Color.js';
import IconVoyageColor from '@lobehub/icons/es/Voyage/components/Color.js';
import IconWandbColor from '@lobehub/icons/es/Wandb/components/Color.js';
import IconWenxinColor from '@lobehub/icons/es/Wenxin/components/Color.js';
import IconWorkersAIColor from '@lobehub/icons/es/WorkersAI/components/Color.js';
import IconXinferenceColor from '@lobehub/icons/es/Xinference/components/Color.js';
import IconXpayColor from '@lobehub/icons/es/Xpay/components/Color.js';
import IconXuanyuanColor from '@lobehub/icons/es/Xuanyuan/components/Color.js';
import IconYiColor from '@lobehub/icons/es/Yi/components/Color.js';
import IconYuanbaoColor from '@lobehub/icons/es/Yuanbao/components/Color.js';
import IconZapierColor from '@lobehub/icons/es/Zapier/components/Color.js';
import IconZeaburColor from '@lobehub/icons/es/Zeabur/components/Color.js';
import IconZencoderColor from '@lobehub/icons/es/Zencoder/components/Color.js';
import IconZeroOneColor from '@lobehub/icons/es/ZeroOne/components/Color.js';
import IconZhipuColor from '@lobehub/icons/es/Zhipu/components/Color.js';

type LobeIcon = ComponentType<{
  className?: string;
  color?: string;
  size?: number;
  style?: CSSProperties;
}>;

const MONO_CANONICAL_REGISTRY: Record<string, LobeIcon> = {
  "ace": IconAceMono,
  "adobe": IconAdobeMono,
  "adobefirefly": IconAdobeFireflyMono,
  "agentvoice": IconAgentVoiceMono,
  "agnesai": IconAgnesAIMono,
  "agui": IconAguiMono,
  "ai2": IconAi2Mono,
  "ai21": IconAi21Mono,
  "ai302": IconAi302Mono,
  "ai360": IconAi360Mono,
  "aihubmix": IconAiHubMixMono,
  "aimass": IconAiMassMono,
  "aionlabs": IconAionLabsMono,
  "airjelly": IconAirJellyMono,
  "aistudio": IconAiStudioMono,
  "akashchat": IconAkashChatMono,
  "alephalpha": IconAlephAlphaMono,
  "alibaba": IconAlibabaMono,
  "alibabacloud": IconAlibabaCloudMono,
  "amdradeoncloud": IconAMDRadeonCloudMono,
  "amp": IconAmpMono,
  "anspire": IconAnspireMono,
  "antgroup": IconAntGroupMono,
  "anthropic": IconAnthropicMono,
  "antigravity": IconAntigravityMono,
  "anyscale": IconAnyscaleMono,
  "apertis": IconApertisMono,
  "apple": IconAppleMono,
  "arcee": IconArceeMono,
  "askverdict": IconAskVerdictMono,
  "assemblyai": IconAssemblyAIMono,
  "atlascloud": IconAtlasCloudMono,
  "automatic": IconAutomaticMono,
  "aws": IconAwsMono,
  "aya": IconAyaMono,
  "azure": IconAzureMono,
  "azureai": IconAzureAIMono,
  "baai": IconBAAIMono,
  "baichuan": IconBaichuanMono,
  "baidu": IconBaiduMono,
  "baiducloud": IconBaiduCloudMono,
  "bailian": IconBailianMono,
  "baseten": IconBasetenMono,
  "bedrock": IconBedrockMono,
  "bfl": IconBflMono,
  "bilibili": IconBilibiliMono,
  "bilibiliindex": IconBilibiliIndexMono,
  "bing": IconBingMono,
  "bocha": IconBochaMono,
  "brave": IconBraveMono,
  "briaai": IconBriaAIMono,
  "browserless": IconBrowserlessMono,
  "burncloud": IconBurnCloudMono,
  "bytedance": IconByteDanceMono,
  "capcut": IconCapCutMono,
  "celestoai": IconCelestoAIMono,
  "centml": IconCentMLMono,
  "cerebras": IconCerebrasMono,
  "chatglm": IconChatGLMMono,
  "cherrystudio": IconCherryStudioMono,
  "chutes": IconChutesMono,
  "civitai": IconCivitaiMono,
  "claude": IconClaudeMono,
  "claudecode": IconClaudeCodeMono,
  "cline": IconClineMono,
  "clipdrop": IconClipdropMono,
  "cloudflare": IconCloudflareMono,
  "codebuddy": IconCodeBuddyMono,
  "codeflicker": IconCodeFlickerMono,
  "codegeex": IconCodeGeeXMono,
  "codex": IconCodexMono,
  "cogvideo": IconCogVideoMono,
  "cogview": IconCogViewMono,
  "cohere": IconCohereMono,
  "colab": IconColabMono,
  "cometapi": IconCometAPIMono,
  "comfyui": IconComfyUIMono,
  "commanda": IconCommandAMono,
  "commandcode": IconCommandCodeMono,
  "copilot": IconCopilotMono,
  "copilotkit": IconCopilotKitMono,
  "coqui": IconCoquiMono,
  "coze": IconCozeMono,
  "crewai": IconCrewAIMono,
  "crusoe": IconCrusoeMono,
  "cursor": IconCursorMono,
  "cybercut": IconCyberCutMono,
  "dalle": IconDalleMono,
  "dbrx": IconDbrxMono,
  "decart": IconDecartMono,
  "deepai": IconDeepAIMono,
  "deepcogito": IconDeepCogitoMono,
  "deepinfra": IconDeepInfraMono,
  "deepl": IconDeepLMono,
  "deepmind": IconDeepMindMono,
  "deepseek": IconDeepSeekMono,
  "devin": IconDevinMono,
  "dify": IconDifyMono,
  "digitalocean": IconDigitalOceanMono,
  "doc2x": IconDoc2XMono,
  "docsearch": IconDocSearchMono,
  "dolphin": IconDolphinMono,
  "dotsstudio": IconDotsStudioMono,
  "doubao": IconDoubaoMono,
  "dreammachine": IconDreamMachineMono,
  "elevenlabs": IconElevenLabsMono,
  "elevenx": IconElevenXMono,
  "essentialai": IconEssentialAIMono,
  "exa": IconExaMono,
  "fal": IconFalMono,
  "fastgpt": IconFastGPTMono,
  "featherless": IconFeatherlessMono,
  "figma": IconFigmaMono,
  "firecrawl": IconFirecrawlMono,
  "fireworks": IconFireworksMono,
  "fishaudio": IconFishAudioMono,
  "flora": IconFloraMono,
  "flowith": IconFlowithMono,
  "flux": IconFluxMono,
  "friendli": IconFriendliMono,
  "gemini": IconGeminiMono,
  "geminicli": IconGeminiCLIMono,
  "gemma": IconGemmaMono,
  "giteeai": IconGiteeAIMono,
  "github": IconGithubMono,
  "githubcopilot": IconGithubCopilotMono,
  "glama": IconGlamaMono,
  "glif": IconGlifMono,
  "glmv": IconGLMVMono,
  "gmicloud": IconGmiCloudMono,
  "google": IconGoogleMono,
  "googlecloud": IconGoogleCloudMono,
  "goose": IconGooseMono,
  "gradio": IconGradioMono,
  "greptile": IconGreptileMono,
  "grok": IconGrokMono,
  "groq": IconGroqMono,
  "hailuo": IconHailuoMono,
  "haiper": IconHaiperMono,
  "happyhorse": IconHappyHorseMono,
  "hedra": IconHedraMono,
  "hermesagent": IconHermesAgentMono,
  "higress": IconHigressMono,
  "huawei": IconHuaweiMono,
  "huaweicloud": IconHuaweiCloudMono,
  "huggingface": IconHuggingFaceMono,
  "hunyuan": IconHunyuanMono,
  "hyperbolic": IconHyperbolicMono,
  "ibm": IconIBMMono,
  "ideogram": IconIdeogramMono,
  "iflytekcloud": IconIFlyTekCloudMono,
  "inception": IconInceptionMono,
  "inceptron": IconInceptronMono,
  "inference": IconInferenceMono,
  "infermatic": IconInfermaticMono,
  "infinigence": IconInfinigenceMono,
  "inflection": IconInflectionMono,
  "internlm": IconInternLMMono,
  "ionet": IconIoNetMono,
  "jimeng": IconJimengMono,
  "jina": IconJinaMono,
  "junie": IconJunieMono,
  "kagi": IconKagiMono,
  "kilocode": IconKiloCodeMono,
  "kimi": IconKimiMono,
  "kiro": IconKiroMono,
  "kling": IconKlingMono,
  "kluster": IconKlusterMono,
  "kolors": IconKolorsMono,
  "krea": IconKreaMono,
  "kwaikat": IconKwaiKATMono,
  "kwaipilot": IconKwaipilotMono,
  "lambda": IconLambdaMono,
  "langchain": IconLangChainMono,
  "langfuse": IconLangfuseMono,
  "langgraph": IconLangGraphMono,
  "langsmith": IconLangSmithMono,
  "leptonai": IconLeptonAIMono,
  "lg": IconLGMono,
  "lightricks": IconLightricksMono,
  "liquid": IconLiquidMono,
  "livekit": IconLiveKitMono,
  "llamaindex": IconLlamaIndexMono,
  "llava": IconLLaVAMono,
  "llmapi": IconLlmApiMono,
  "lmstudio": IconLmStudioMono,
  "lobehub": IconLobeHubMono,
  "longcat": IconLongCatMono,
  "lovable": IconLovableMono,
  "lovart": IconLovartMono,
  "luma": IconLumaMono,
  "magic": IconMagicMono,
  "make": IconMakeMono,
  "manus": IconManusMono,
  "mastra": IconMastraMono,
  "mcp": IconMCPMono,
  "mcpso": IconMcpSoMono,
  "menlo": IconMenloMono,
  "meshy": IconMeshyMono,
  "meta": IconMetaMono,
  "metaai": IconMetaAIMono,
  "metagpt": IconMetaGPTMono,
  "microsoft": IconMicrosoftMono,
  "midjourney": IconMidjourneyMono,
  "minimax": IconMinimaxMono,
  "mistral": IconMistralMono,
  "modelscope": IconModelScopeMono,
  "monica": IconMonicaMono,
  "moonshot": IconMoonshotMono,
  "morph": IconMorphMono,
  "moxt": IconMoxtMono,
  "myshell": IconMyShellMono,
  "n8n": IconN8nMono,
  "nanobanana": IconNanoBananaMono,
  "nebius": IconNebiusMono,
  "newapi": IconNewAPIMono,
  "nextbit": IconNextbitMono,
  "notebooklm": IconNotebookLMMono,
  "notion": IconNotionMono,
  "nousresearch": IconNousResearchMono,
  "nova": IconNovaMono,
  "novelai": IconNovelAIMono,
  "novita": IconNovitaMono,
  "nplcloud": IconNPLCloudMono,
  "nvidia": IconNvidiaMono,
  "obsidian": IconObsidianMono,
  "ollama": IconOllamaMono,
  "openai": IconOpenAIMono,
  "openchat": IconOpenChatMono,
  "openclaw": IconOpenClawMono,
  "opencode": IconOpenCodeMono,
  "openhands": IconOpenHandsMono,
  "openhuman": IconOpenHumanMono,
  "openrouter": IconOpenRouterMono,
  "openwebui": IconOpenWebUIMono,
  "palm": IconPaLMMono,
  "parasail": IconParasailMono,
  "perceptron": IconPerceptronMono,
  "perplexity": IconPerplexityMono,
  "phala": IconPhalaMono,
  "phidata": IconPhidataMono,
  "phind": IconPhindMono,
  "pi": IconPiMono,
  "pika": IconPikaMono,
  "pixverse": IconPixVerseMono,
  "player2": IconPlayer2Mono,
  "poe": IconPoeMono,
  "pollinations": IconPollinationsMono,
  "poolside": IconPoolsideMono,
  "ppio": IconPPIOMono,
  "prunaai": IconPrunaAIMono,
  "pydanticai": IconPydanticAIMono,
  "qingyan": IconQingyanMono,
  "qiniu": IconQiniuMono,
  "qoder": IconQoderMono,
  "qwen": IconQwenMono,
  "railway": IconRailwayMono,
  "recraft": IconRecraftMono,
  "reka": IconRekaMono,
  "relace": IconRelaceMono,
  "replicate": IconReplicateMono,
  "replit": IconReplitMono,
  "reve": IconReveMono,
  "roocode": IconRooCodeMono,
  "rsshub": IconRSSHubMono,
  "runway": IconRunwayMono,
  "rwkv": IconRwkvMono,
  "sakana": IconSakanaMono,
  "sambanova": IconSambaNovaMono,
  "search1api": IconSearch1APIMono,
  "searchapi": IconSearchApiMono,
  "searxng": IconSearXNGMono,
  "sensenova": IconSenseNovaMono,
  "siliconcloud": IconSiliconCloudMono,
  "sillytavern": IconSillyTavernMono,
  "skywork": IconSkyworkMono,
  "slock": IconSlockMono,
  "smithery": IconSmitheryMono,
  "snowflake": IconSnowflakeMono,
  "sophnet": IconSophNetMono,
  "sora": IconSoraMono,
  "spark": IconSparkMono,
  "speedai": IconSpeedAIMono,
  "stability": IconStabilityMono,
  "statecloud": IconStateCloudMono,
  "stepfun": IconStepfunMono,
  "straico": IconStraicoMono,
  "streamlake": IconStreamLakeMono,
  "submodel": IconSubModelMono,
  "suno": IconSunoMono,
  "sync": IconSyncMono,
  "targon": IconTargonMono,
  "tavily": IconTavilyMono,
  "tencent": IconTencentMono,
  "tencentcloud": IconTencentCloudMono,
  "tiangong": IconTiangongMono,
  "tii": IconTIIMono,
  "together": IconTogetherMono,
  "topazlabs": IconTopazLabsMono,
  "trae": IconTraeMono,
  "tripo": IconTripoMono,
  "turix": IconTuriXMono,
  "udio": IconUdioMono,
  "unionalpha": IconUnionAlphaMono,
  "unsloth": IconUnslothMono,
  "unstructured": IconUnstructuredMono,
  "upstage": IconUpstageMono,
  "v0": IconV0Mono,
  "vectorizerai": IconVectorizerAIMono,
  "venice": IconVeniceMono,
  "vercel": IconVercelMono,
  "vertexai": IconVertexAIMono,
  "vidu": IconViduMono,
  "viggle": IconViggleMono,
  "vllm": IconVllmMono,
  "volcengine": IconVolcengineMono,
  "voyage": IconVoyageMono,
  "wafer": IconWaferMono,
  "wandb": IconWandbMono,
  "wavespeed": IconWaveSpeedMono,
  "wenxin": IconWenxinMono,
  "windsurf": IconWindsurfMono,
  "workersai": IconWorkersAIMono,
  "worldrouter": IconWorldRouterMono,
  "xai": IconXAIMono,
  "xiaomimimo": IconXiaomiMiMoMono,
  "xinference": IconXinferenceMono,
  "xpay": IconXpayMono,
  "xuanyuan": IconXuanyuanMono,
  "yandex": IconYandexMono,
  "yi": IconYiMono,
  "youmind": IconYouMindMono,
  "yuanbao": IconYuanbaoMono,
  "zai": IconZAIMono,
  "zapier": IconZapierMono,
  "zeabur": IconZeaburMono,
  "zencoder": IconZencoderMono,
  "zenmux": IconZenMuxMono,
  "zeroone": IconZeroOneMono,
  "zhipu": IconZhipuMono,
};

const MONO_LEGACY_ALIASES: Record<string, LobeIcon> = {
  "agnes": MONO_CANONICAL_REGISTRY["agnesai"],
  "ali-cloud": MONO_CANONICAL_REGISTRY["alibabacloud"],
  "aliyun": MONO_CANONICAL_REGISTRY["alibabacloud"],
  "apimart": MONO_CANONICAL_REGISTRY["openai"],
  "baidu-cloud": MONO_CANONICAL_REGISTRY["baiducloud"],
  "bailian": MONO_CANONICAL_REGISTRY["bailian"],
  "byte-dance": MONO_CANONICAL_REGISTRY["bytedance"],
  "chatgpt": MONO_CANONICAL_REGISTRY["openai"],
  "claude": MONO_CANONICAL_REGISTRY["claude"],
  "comfy": MONO_CANONICAL_REGISTRY["comfyui"],
  "comfy-ui": MONO_CANONICAL_REGISTRY["comfyui"],
  "dashscope": MONO_CANONICAL_REGISTRY["alibabacloud"],
  "dream-machine": MONO_CANONICAL_REGISTRY["dreammachine"],
  "eleven-labs": MONO_CANONICAL_REGISTRY["elevenlabs"],
  "fish-audio": MONO_CANONICAL_REGISTRY["fishaudio"],
  "google-ai": MONO_CANONICAL_REGISTRY["google"],
  "google-cloud": MONO_CANONICAL_REGISTRY["googlecloud"],
  "googlecloud": MONO_CANONICAL_REGISTRY["googlecloud"],
  "gpt-image": MONO_CANONICAL_REGISTRY["openai"],
  "gpt-image-2": MONO_CANONICAL_REGISTRY["openai"],
  "grok-imagine": MONO_CANONICAL_REGISTRY["grok"],
  "hailuoai": MONO_CANONICAL_REGISTRY["hailuo"],
  "huawei-cloud": MONO_CANONICAL_REGISTRY["huaweicloud"],
  "hugging-face": MONO_CANONICAL_REGISTRY["huggingface"],
  "huggingface": MONO_CANONICAL_REGISTRY["huggingface"],
  "jimeng_image": MONO_CANONICAL_REGISTRY["jimeng"],
  "jimeng_video": MONO_CANONICAL_REGISTRY["jimeng"],
  "jimeng-video": MONO_CANONICAL_REGISTRY["jimeng"],
  "lm-studio": MONO_CANONICAL_REGISTRY["lmstudio"],
  "lmstudio": MONO_CANONICAL_REGISTRY["lmstudio"],
  "minimax_hailuo": MONO_CANONICAL_REGISTRY["hailuo"],
  "mj": MONO_CANONICAL_REGISTRY["midjourney"],
  "model-scope": MONO_CANONICAL_REGISTRY["modelscope"],
  "open-ai": MONO_CANONICAL_REGISTRY["openai"],
  "open-router": MONO_CANONICAL_REGISTRY["openrouter"],
  "pix-verse": MONO_CANONICAL_REGISTRY["pixverse"],
  "sd": MONO_CANONICAL_REGISTRY["stability"],
  "silicon-cloud": MONO_CANONICAL_REGISTRY["siliconcloud"],
  "stable-diffusion": MONO_CANONICAL_REGISTRY["stability"],
  "tencent-cloud": MONO_CANONICAL_REGISTRY["tencentcloud"],
  "tongyi": MONO_CANONICAL_REGISTRY["qwen"],
  "vertex": MONO_CANONICAL_REGISTRY["vertexai"],
  "vertex-ai": MONO_CANONICAL_REGISTRY["vertexai"],
  "volcano": MONO_CANONICAL_REGISTRY["volcengine"],
  "wanx": MONO_CANONICAL_REGISTRY["alibaba"],
  "x-ai": MONO_CANONICAL_REGISTRY["xai"],
};

export const ICON_REGISTRY: Record<string, LobeIcon> = {
  ...MONO_CANONICAL_REGISTRY,
  ...MONO_LEGACY_ALIASES,
};

const COLOR_CANONICAL_REGISTRY: Record<string, LobeIcon> = {
  "adobe": IconAdobeColor,
  "adobefirefly": IconAdobeFireflyColor,
  "agentvoice": IconAgentVoiceColor,
  "ai2": IconAi2Color,
  "ai302": IconAi302Color,
  "ai360": IconAi360Color,
  "aihubmix": IconAiHubMixColor,
  "aimass": IconAiMassColor,
  "aionlabs": IconAionLabsColor,
  "airjelly": IconAirJellyColor,
  "akashchat": IconAkashChatColor,
  "alibaba": IconAlibabaColor,
  "alibabacloud": IconAlibabaCloudColor,
  "amdradeoncloud": IconAMDRadeonCloudColor,
  "amp": IconAmpColor,
  "anspire": IconAnspireColor,
  "antgroup": IconAntGroupColor,
  "antigravity": IconAntigravityColor,
  "anyscale": IconAnyscaleColor,
  "apertis": IconApertisColor,
  "arcee": IconArceeColor,
  "askverdict": IconAskVerdictColor,
  "assemblyai": IconAssemblyAIColor,
  "automatic": IconAutomaticColor,
  "aws": IconAwsColor,
  "aya": IconAyaColor,
  "azure": IconAzureColor,
  "azureai": IconAzureAIColor,
  "baichuan": IconBaichuanColor,
  "baidu": IconBaiduColor,
  "baiducloud": IconBaiduCloudColor,
  "bailian": IconBailianColor,
  "bedrock": IconBedrockColor,
  "bilibili": IconBilibiliColor,
  "bing": IconBingColor,
  "bocha": IconBochaColor,
  "brave": IconBraveColor,
  "briaai": IconBriaAIColor,
  "burncloud": IconBurnCloudColor,
  "bytedance": IconByteDanceColor,
  "celestoai": IconCelestoAIColor,
  "centml": IconCentMLColor,
  "cerebras": IconCerebrasColor,
  "chatglm": IconChatGLMColor,
  "cherrystudio": IconCherryStudioColor,
  "civitai": IconCivitaiColor,
  "claude": IconClaudeColor,
  "claudecode": IconClaudeCodeColor,
  "cloudflare": IconCloudflareColor,
  "codebuddy": IconCodeBuddyColor,
  "codeflicker": IconCodeFlickerColor,
  "codegeex": IconCodeGeeXColor,
  "codex": IconCodexColor,
  "cogvideo": IconCogVideoColor,
  "cogview": IconCogViewColor,
  "cohere": IconCohereColor,
  "colab": IconColabColor,
  "cometapi": IconCometAPIColor,
  "comfyui": IconComfyUIColor,
  "commanda": IconCommandAColor,
  "commandcode": IconCommandCodeColor,
  "copilot": IconCopilotColor,
  "copilotkit": IconCopilotKitColor,
  "coqui": IconCoquiColor,
  "crewai": IconCrewAIColor,
  "crusoe": IconCrusoeColor,
  "dalle": IconDalleColor,
  "dbrx": IconDbrxColor,
  "decart": IconDecartColor,
  "deepcogito": IconDeepCogitoColor,
  "deepinfra": IconDeepInfraColor,
  "deepl": IconDeepLColor,
  "deepmind": IconDeepMindColor,
  "deepseek": IconDeepSeekColor,
  "devin": IconDevinColor,
  "dify": IconDifyColor,
  "doc2x": IconDoc2XColor,
  "docsearch": IconDocSearchColor,
  "doubao": IconDoubaoColor,
  "essentialai": IconEssentialAIColor,
  "exa": IconExaColor,
  "fal": IconFalColor,
  "fastgpt": IconFastGPTColor,
  "featherless": IconFeatherlessColor,
  "figma": IconFigmaColor,
  "firecrawl": IconFirecrawlColor,
  "fireworks": IconFireworksColor,
  "gemini": IconGeminiColor,
  "geminicli": IconGeminiCLIColor,
  "gemma": IconGemmaColor,
  "glmv": IconGLMVColor,
  "google": IconGoogleColor,
  "googlecloud": IconGoogleCloudColor,
  "gradio": IconGradioColor,
  "greptile": IconGreptileColor,
  "hailuo": IconHailuoColor,
  "higress": IconHigressColor,
  "huawei": IconHuaweiColor,
  "huaweicloud": IconHuaweiCloudColor,
  "huggingface": IconHuggingFaceColor,
  "hunyuan": IconHunyuanColor,
  "hyperbolic": IconHyperbolicColor,
  "iflytekcloud": IconIFlyTekCloudColor,
  "inceptron": IconInceptronColor,
  "infermatic": IconInfermaticColor,
  "infinigence": IconInfinigenceColor,
  "internlm": IconInternLMColor,
  "jimeng": IconJimengColor,
  "junie": IconJunieColor,
  "kimi": IconKimiColor,
  "kiro": IconKiroColor,
  "kling": IconKlingColor,
  "kluster": IconKlusterColor,
  "kolors": IconKolorsColor,
  "kwaipilot": IconKwaipilotColor,
  "langchain": IconLangChainColor,
  "langfuse": IconLangfuseColor,
  "langgraph": IconLangGraphColor,
  "langsmith": IconLangSmithColor,
  "leptonai": IconLeptonAIColor,
  "lg": IconLGColor,
  "livekit": IconLiveKitColor,
  "llamaindex": IconLlamaIndexColor,
  "llava": IconLLaVAColor,
  "llmapi": IconLlmApiColor,
  "lobehub": IconLobeHubColor,
  "longcat": IconLongCatColor,
  "lovable": IconLovableColor,
  "luma": IconLumaColor,
  "make": IconMakeColor,
  "mcpso": IconMcpSoColor,
  "menlo": IconMenloColor,
  "meshy": IconMeshyColor,
  "meta": IconMetaColor,
  "metaai": IconMetaAIColor,
  "microsoft": IconMicrosoftColor,
  "minimax": IconMinimaxColor,
  "mistral": IconMistralColor,
  "modelscope": IconModelScopeColor,
  "monica": IconMonicaColor,
  "morph": IconMorphColor,
  "moxt": IconMoxtColor,
  "myshell": IconMyShellColor,
  "n8n": IconN8nColor,
  "nanobanana": IconNanoBananaColor,
  "newapi": IconNewAPIColor,
  "nextbit": IconNextbitColor,
  "nova": IconNovaColor,
  "novita": IconNovitaColor,
  "nplcloud": IconNPLCloudColor,
  "nvidia": IconNvidiaColor,
  "obsidian": IconObsidianColor,
  "openchat": IconOpenChatColor,
  "openclaw": IconOpenClawColor,
  "openhands": IconOpenHandsColor,
  "openrouter": IconOpenRouterColor,
  "palm": IconPaLMColor,
  "perplexity": IconPerplexityColor,
  "phala": IconPhalaColor,
  "phidata": IconPhidataColor,
  "pixverse": IconPixVerseColor,
  "player2": IconPlayer2Color,
  "poe": IconPoeColor,
  "poolside": IconPoolsideColor,
  "ppio": IconPPIOColor,
  "prunaai": IconPrunaAIColor,
  "pydanticai": IconPydanticAIColor,
  "qingyan": IconQingyanColor,
  "qiniu": IconQiniuColor,
  "qoder": IconQoderColor,
  "qwen": IconQwenColor,
  "replit": IconReplitColor,
  "rsshub": IconRSSHubColor,
  "rwkv": IconRwkvColor,
  "sakana": IconSakanaColor,
  "sambanova": IconSambaNovaColor,
  "search1api": IconSearch1APIColor,
  "searxng": IconSearXNGColor,
  "sensenova": IconSenseNovaColor,
  "siliconcloud": IconSiliconCloudColor,
  "sillytavern": IconSillyTavernColor,
  "skywork": IconSkyworkColor,
  "smithery": IconSmitheryColor,
  "snowflake": IconSnowflakeColor,
  "sophnet": IconSophNetColor,
  "sora": IconSoraColor,
  "spark": IconSparkColor,
  "speedai": IconSpeedAIColor,
  "stability": IconStabilityColor,
  "statecloud": IconStateCloudColor,
  "straico": IconStraicoColor,
  "streamlake": IconStreamLakeColor,
  "submodel": IconSubModelColor,
  "targon": IconTargonColor,
  "tavily": IconTavilyColor,
  "tencent": IconTencentColor,
  "tencentcloud": IconTencentCloudColor,
  "tiangong": IconTiangongColor,
  "tii": IconTIIColor,
  "together": IconTogetherColor,
  "trae": IconTraeColor,
  "tripo": IconTripoColor,
  "udio": IconUdioColor,
  "unionalpha": IconUnionAlphaColor,
  "unsloth": IconUnslothColor,
  "unstructured": IconUnstructuredColor,
  "upstage": IconUpstageColor,
  "venice": IconVeniceColor,
  "vertexai": IconVertexAIColor,
  "vidu": IconViduColor,
  "vllm": IconVllmColor,
  "volcengine": IconVolcengineColor,
  "voyage": IconVoyageColor,
  "wandb": IconWandbColor,
  "wenxin": IconWenxinColor,
  "workersai": IconWorkersAIColor,
  "xinference": IconXinferenceColor,
  "xpay": IconXpayColor,
  "xuanyuan": IconXuanyuanColor,
  "yi": IconYiColor,
  "yuanbao": IconYuanbaoColor,
  "zapier": IconZapierColor,
  "zeabur": IconZeaburColor,
  "zencoder": IconZencoderColor,
  "zeroone": IconZeroOneColor,
  "zhipu": IconZhipuColor,
};

const COLOR_LEGACY_ALIASES: Record<string, LobeIcon> = {
  "ali-cloud": COLOR_CANONICAL_REGISTRY["alibabacloud"],
  "aliyun": COLOR_CANONICAL_REGISTRY["alibabacloud"],
  "baidu-cloud": COLOR_CANONICAL_REGISTRY["baiducloud"],
  "bailian": COLOR_CANONICAL_REGISTRY["bailian"],
  "byte-dance": COLOR_CANONICAL_REGISTRY["bytedance"],
  "claude": COLOR_CANONICAL_REGISTRY["claude"],
  "comfy": COLOR_CANONICAL_REGISTRY["comfyui"],
  "comfy-ui": COLOR_CANONICAL_REGISTRY["comfyui"],
  "dashscope": COLOR_CANONICAL_REGISTRY["alibabacloud"],
  "google-ai": COLOR_CANONICAL_REGISTRY["google"],
  "google-cloud": COLOR_CANONICAL_REGISTRY["googlecloud"],
  "googlecloud": COLOR_CANONICAL_REGISTRY["googlecloud"],
  "hailuoai": COLOR_CANONICAL_REGISTRY["hailuo"],
  "huawei-cloud": COLOR_CANONICAL_REGISTRY["huaweicloud"],
  "hugging-face": COLOR_CANONICAL_REGISTRY["huggingface"],
  "huggingface": COLOR_CANONICAL_REGISTRY["huggingface"],
  "jimeng_image": COLOR_CANONICAL_REGISTRY["jimeng"],
  "jimeng_video": COLOR_CANONICAL_REGISTRY["jimeng"],
  "jimeng-video": COLOR_CANONICAL_REGISTRY["jimeng"],
  "minimax_hailuo": COLOR_CANONICAL_REGISTRY["hailuo"],
  "model-scope": COLOR_CANONICAL_REGISTRY["modelscope"],
  "open-router": COLOR_CANONICAL_REGISTRY["openrouter"],
  "pix-verse": COLOR_CANONICAL_REGISTRY["pixverse"],
  "sd": COLOR_CANONICAL_REGISTRY["stability"],
  "silicon-cloud": COLOR_CANONICAL_REGISTRY["siliconcloud"],
  "stable-diffusion": COLOR_CANONICAL_REGISTRY["stability"],
  "tencent-cloud": COLOR_CANONICAL_REGISTRY["tencentcloud"],
  "tongyi": COLOR_CANONICAL_REGISTRY["qwen"],
  "vertex": COLOR_CANONICAL_REGISTRY["vertexai"],
  "vertex-ai": COLOR_CANONICAL_REGISTRY["vertexai"],
  "volcano": COLOR_CANONICAL_REGISTRY["volcengine"],
  "wanx": COLOR_CANONICAL_REGISTRY["alibaba"],
};

export const COLOR_ICON_REGISTRY: Record<string, LobeIcon> = {
  ...COLOR_CANONICAL_REGISTRY,
  ...COLOR_LEGACY_ALIASES,
};

export const ICON_KEYS = Object.keys(MONO_CANONICAL_REGISTRY).sort();

const useStyles = createStyles(({ token, css }) => ({
  wrap: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 1;
    color: ${token.colorText};
  `,
  fallback: css`
    background: ${token.colorFillTertiary};
    color: ${token.colorTextSecondary};
    font-weight: 600;
  `,
}));

export interface ModelIconProps {
  iconKey?: string;
  size?: number;
  fallbackLabel?: string;
  variant?: 'color' | 'mono';
  className?: string;
}

const ModelIcon = memo<ModelIconProps>(
  ({ iconKey, size = 20, fallbackLabel, variant = 'color', className }) => {
    const { styles, cx } = useStyles();

    const key = (iconKey || '').trim().toLowerCase();
    const MonoIcon = key ? ICON_REGISTRY[key] : undefined;
    const ColorIcon = key ? COLOR_ICON_REGISTRY[key] : undefined;

    if (variant === 'mono' && MonoIcon) {
      return (
        <span
          className={cx(styles.wrap, className)}
          style={{ width: size, height: size }}
          title={iconKey}
        >
          <MonoIcon size={size} />
        </span>
      );
    }

    if (variant === 'color' && ColorIcon) {
      return (
        <span
          className={cx(styles.wrap, className)}
          style={{ width: size, height: size }}
          title={iconKey}
        >
          <ColorIcon size={size} />
        </span>
      );
    }

    if (MonoIcon) {
      return (
        <span
          className={cx(styles.wrap, className)}
          style={{ width: size, height: size }}
          title={iconKey}
        >
          <MonoIcon size={size} />
        </span>
      );
    }

    const first = (fallbackLabel || iconKey || '?')
      .trim()
      .charAt(0)
      .toUpperCase();
    return (
      <Avatar
        size={size}
        className={cx(styles.fallback, className)}
        style={{ fontSize: Math.max(11, Math.round(size * 0.45)) }}
      >
        {first}
      </Avatar>
    );
  },
);

ModelIcon.displayName = 'ModelIcon';

export default ModelIcon;
